<template>
  <div class="projects-box">
    <menuBox :step="3"></menuBox>
    <div class="title-box">
      Contact
    </div>
    <div class="contact-box">
      <div class="content">
        <div class="title">Contact Us. It’s Easy.</div>
        <div class="text">Leverage agile frameworks to provide a robust synopsis for high level overviews. Iterative
          approaches to corporate strategy foster collaborative.</div>
        <div class="list">
          <img src="../assets/tel.png" alt="">
          <div>
            <p>Tel</p>
            <span>94732971</span>
          </div>
        </div>
        <div class="list">
          <img src="../assets/email.png" alt="">
          <div>
            <p>Email</p>
            <span>happyandlivelyfanzi@gmail.com</span>
          </div>
        </div>
        <div class="list">
          <img src="../assets/tel.png" alt="">
          <div>
            <p>Address</p>
            <span>UNIT 08, 15/F WITTY COMMERCIAL BUILDING 1A-1L TUNG CHOI STREET, KOWLOON HONG KONG
            </span>
          </div>
        </div>
      </div>
      <div class="content-fotter">
        <div class="lineBox">
          <div class="line">
            <input type="text" placeholder="john david">
            <input type="text" placeholder="consult@mail.com">
          </div>
          <div class="line">
            <input type="text" placeholder="+008 654 231">
            <input type="text" placeholder="yourcompany.com">
          </div>
          <textarea class="message" type="text"
            placeholder="Briefly tell us about your project and your current goals. How can we help you?" />
        </div>
        <div class="btn" @click="submit">Send Message</div>
      </div>
    </div>
    <footerBox :step="3"></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "projects",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
    submit() {
      alert('success!')
    }
  },
};
</script>
<style lang="less" scoped>
.projects-box {
  background: #191A20;

  .title-box {
    margin: 0 305px;
    background-image: url(../assets/projects.png);
    height: 175px;
    line-height: 175px;
    text-align: center;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;
    font-size: 42px;
    font-family: Roboto, Roboto;
    font-weight: 600;
    color: #FFFFFF;
    box-sizing: border-box;
  }

  .contact-box {
    padding: 62px 305px 162px;
    display: flex;

    .content {
      margin-right: 100px;

      .title {
        margin-bottom: 13px;
        max-width: 400px;
        font-size: 45px;
        font-family: Roboto, Roboto;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 52px;
      }

      .text {
        margin-bottom: 38px;
        max-width: 400px;
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
      }

      .list {
        margin-bottom: 56px;
        display: flex;
        align-items: center;

        img {
          margin-right: 16px;
          width: 53px;
          height: 53px;
        }

        p {
          margin-bottom: 3px;
          font-size: 16px;
          font-family: Lato, Lato;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
        }

        span {
          font-size: 20px;
          font-family: Cabin, Cabin;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 23px;
        }
      }
    }

    .lineBox {
      .line {
        margin-bottom: 16px;
        display: flex;

        input {
          padding: 0 20px;
          margin-right: 24px;
          width: 318px;
          height: 68px;
          background: #F5F5F5;
          border: none;
          border-radius: 10px;
        }

        input:nth-child(2) {
          margin-right: 0;
        }
      }

      textarea {
        padding: 10px 20px;
        width: 100%;
        height: 157px;
        background: #F5F5F5;
        border: none;
        box-sizing: border-box;
        border-radius: 10px;
      }
    }
  }

}

.btn {
  display: table;
  cursor: pointer;
  margin-top: 28px;
  padding: 16px 28px;
  background: #FF4E4E;
  font-size: 18px;
  font-family: Lato, Lato;
  font-weight: 600;
  color: #FFFFFF;
  border-radius: 42px 42px 42px 42px
}
</style>
